import { render, staticRenderFns } from "./SellerReview.vue?vue&type=template&id=28733035"
import script from "./SellerReview.vue?vue&type=script&lang=js"
export * from "./SellerReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports